import React from "react";
import Ticker from "../components/smsc/Ticker";


const Minted = () => {

    // Get time in 42 days

    return(
        <section className="pt-[40px] pb-[20px] lg:py-[107px] text-[#0D3727] ">

            <div className="container-theme flex items-center flex-col text-center">
                <h2 className="count-up leading-none">
                <Ticker end={6000}/>
                </h2>
                <p className='text-[16px] leading-[19px] lg:text-[24px] tk-fatfrank tracking-wide font-bold pt-[24px] uppercase'>
                sloths, living in<br className="lg:hidden"/> the Ethereum blockchain
                </p>

            </div>



        </section>
    )
}

export default Minted